// extracted by mini-css-extract-plugin
export default {"textFieldroot":"PersianSupport_textFieldroot__-suLX","textFieldShrink":"PersianSupport_textFieldShrink__MZGfm"};